import $ from "jquery";
import storage from "sessionstorage";
import Keycloak from "keycloak-js";

const JSCOOKIE_NAME = "ORCA_LOGIN";
const COOKIE_EXPIRES = 5; // 5 min expiry...

/**
 * Set Short-Lived JS Cookie to prevent Icon flickering
 */
function setLoginCookie(authenticated) {

    const expires = new Date();
    expires.setTime(expires.getTime() + 60* COOKIE_EXPIRES);
    if (authenticated) {
        storage.setItem(JSCOOKIE_NAME, expires);
    } else {
        storage.setItem(JSCOOKIE_NAME, 0);
    }
}

/**
 * Toggle Icon visibility according to Auth-State
 */
function setIcons(authenticated) {
    if(authenticated) {
        $(".header-menu .menu-items .menu-item.loginout .logout").removeClass("hidden");
        $(".header-menu .menu-items .menu-item.loginout .login").addClass("hidden");
    } else {
        $(".header-menu .menu-items .menu-item.loginout .logout").addClass("hidden");
        $(".header-menu .menu-items .menu-item.loginout .login").removeClass("hidden");
    }
}

/**
 * Init-Login/-out Button on Page load
 */
export const initLoginoutBtn = () => {
    $(function () {
        //console.log("The Location", window.location);
        //console.log("The cookies", document.cookies );

        const keycloak = Keycloak(process.env.KEYCLOAK_CONFIG);
        const cookieLoggedIn = storage.getItem(JSCOOKIE_NAME);
        
        const now = new Date();
        if (cookieLoggedIn === undefined || cookieLoggedIn < now.getTime()) {
            keycloak
                .init({
                    onLoad: "check-sso",
                    pkceMethod: "S256",
                    promiseType: "native",
                    silentCheckSsoRedirectUri: window.location.origin + '/moveo/test/login/silent-sso.html'
                })
                .then((authenticated) => {
                    setIcons(authenticated);
                    setLoginCookie(authenticated);
                })
            ;
        } else {
            //console.log("Got OrcaLogin from JS-Cookie", cookieLoggedIn);
            setIcons(cookieLoggedIn);
        }

        $(".header-menu .menu-items .menu-item.loginout .login").click(function() {
            keycloak.login({
                redirectUri: window.location.href
            });
        });

    }); 
}
